import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

type Props = SvgIconProps;

const PlateCoverIcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon viewBox="0 0 25 16" {...props}>
      <path
        d="M24.9228 12.7469C24.827 12.5938 24.6593 12.5 24.479 12.5H0.520739C0.340514 12.5 0.172838 12.5938 0.0780141 12.7469C-0.0167614 12.9 -0.0261364 13.0917 0.0551136 13.2531C0.786364 14.7167 2.25614 15.625 3.89154 15.625H21.1082C22.7426 15.625 24.2123 14.7167 24.9457 13.2542C25.0249 13.0917 25.0176 12.901 24.9228 12.7469Z"
        fill={props.htmlColor ?? colors.primary}
      />
      <path
        d="M13.9287 2.19165C14.0141 1.99893 14.0631 1.78643 14.0631 1.5625C14.0631 0.701026 13.3621 0 12.5006 0C11.6391 0 10.9381 0.701026 10.9381 1.5625C10.9381 1.78648 10.9871 1.99898 11.0725 2.19165C6.35269 2.84063 2.62559 6.64063 2.14746 11.4584H22.8527C22.3746 6.64273 18.6464 2.84063 13.9287 2.19165ZM12.0141 5.20728C9.10059 5.4 6.59121 7.30205 5.62349 10.0531C5.54849 10.2667 5.34639 10.401 5.13184 10.401C5.07456 10.401 5.01621 10.3917 4.95894 10.3719C4.68809 10.276 4.54541 9.97915 4.64019 9.70728C5.74644 6.56143 8.61416 4.3875 11.9454 4.16768C12.2214 4.14995 12.4798 4.36558 12.4996 4.65308C12.5183 4.94063 12.3016 5.18853 12.0141 5.20728Z"
        fill={props.htmlColor ?? colors.primary}
      />
    </SvgIcon>
  );
};

export default PlateCoverIcon;
